module.exports = __webpack_public_path__ + "img/edit_square.14d62a24.svg";